import { Box, Grid } from "@mui/material";

import FeedResults from "./FeedResults";
import FeedResultsMobile from "./FeedResultsMobile";
import ModalTrigger from "../Common/ModalTrigger";
import CustomLink from "../Common/CustomLink";

const Glyphosate = (props) => {
  return (
    <Grid
      flexWrap="nowrap"
      item
      container
      direction={{ xs: "column", sm: "column", md: "row" }}
      sx={{
        marginTop: { xs: "50px", sm: "50px", md: "90px" },
      }}
      justifyContent="space-between"
      alignItems="center"
      backgroundColor="#F8F8F8"
    >
      <Grid
        item
        xs
        p={3}
        className="four-one"
        sx={{
          maxWidth: { md: "450px !Important" },
          textAlign: { xs: "left", sm: "center", md: "left" },
        }}
      >
        <Box>
          <h3>Focus on glyphosate</h3>
          <p className="paragraph">
            Glyphosate is {" "}
            <CustomLink
              href="https://eur-lex.europa.eu/eli/reg_impl/2023/2660/oj"
              text="approved for use in the EU"
            />{" "}
            until 15 December 2033. It can be used as an active substance in plant protection products (PPPs), provided each PPP is authorised by national authorities following a safety evaluation. This section presents all data received on glyphosate and its metabolites/degradation products for the reporting period.{" "}
          </p>
          <p className="paragraph">
            In 2024, 28 countries analysed glyphosate residues in 14,143 food samples. Residues were also identified in 436 feed samples and 28 fish samples.
          </p>
          <p className="paragraph">
            In 98.2% of the food samples, glyphosate was not quantified.</p><p className="paragraph">In 1.6% (228) of samples, glyphosate was quantified at levels above the LOQ but below the MRL, while 0.2% (26) exceeded the MRL. When measurement uncertainty was taken into account, 0.1% (16) of samples were reported as non-compliant, mainly in buckwheat and other pseudo-cereals, honey and other apicultural products.</p><p className="paragraph">In all 429 baby food samples, glyphosate residues were not quantified.
          </p>
          <p className="paragraph">
            The following glyphosate{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="metabolites"
            />{" "}
           were quantified in food: aminomethylphosphonic acid (AMPA) (0.6%, mainly in cultivated fungi) and AMPA-N-acetyl (0.2%). N-acetyl glyphosate was not quantified.
          </p>
          <p className="paragraph">
            Trimethyl-sulfonium cation resulting from the use of glyphosate was analysed by 10 Member States and was quantified in 25 samples (0.6%), mainly in cultivated fungi and citrus fruits.
          </p>
          <p className="paragraph">
            In feed, where MRLs are not set, glyphosate-related substances were quantified as follows: glyphosate (25.9%), AMPA (16.8%) and AMPA-N-acetyl (46.9%).
          </p>
        </Box>
      </Grid>
      <Grid
        item
        xs
        className="four-two"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <Box
          p={3}
          sx={{
            display: { xs: "none", sm: "none", md: "block" },
          }}
        >
          <FeedResults />
        </Box>
        <Box
          sx={{
            display: { xs: "block", sm: "block", md: "none" },
            width: "100%",
            maxHeight: "600px",
            maxWidth: "300px",
          }}
          display="flex"
          flexDirection="column"
          alignItems="start"
          justifyContent="flex-start"
        >
          <FeedResultsMobile />
        </Box>
      </Grid>
    </Grid>
  );
};

export default Glyphosate;
